import React from "react";
import ItemExpandRow from "./ItemExpandRow";

const ItemExpandTable = ({ item }) => {
  return (
    <>
      <tr className="border ">
        <td colSpan="7" className="p-2">
          <div className="flex">
            <table className="w-full text-sm text-left text-gray-400">
              <thead className="text-xs text-gray-700 uppercase bg-gray-50">
                <tr>
                  <th scope="col" className="px-6 py-3">
                  
                  </th>
                  <th scope="col" className="px-6 py-3">
                  </th>
                  <th scope="col" className="px-6 py-3">
                    إتاحة المنتج
                  </th>
                  <th scope="col" className="px-6 py-3">
                    السعر العراقي
                  </th>
                  <th scope="col" className="px-6 py-3">
                    المناطق المتاحة للجمهور
                  </th>
                  <th scope="col" className="px-6 py-3">
                    الأكثر مبيعاً
                  </th>
                  <th scope="col" colSpan="3" className="px-6 py-3 text-right">
                    إسم المنتج
                  </th>
                  <th scope="col" className="px-6 py-3 text-right">
                    صورة المنتج
                  </th>
                </tr>
              </thead>
              <tbody>
                {item.children.map((child) => {
                  return <ItemExpandRow item={child} key={child.id} />;
                })}
              </tbody>
            </table>
          </div>
        </td>
      </tr>
    </>
  );
};

export default ItemExpandTable;
